import React, { useReducer } from "react";
import translate from "@/i18n/translate";
import WidgetLoader from "../common/elements/WidgetLoader";

export interface ParticipationOverview {
  assessmentCount: number;
  courseCount: number;
  instructorCount: number;
  studentCount: number;
}
interface StudentLearningAssesmentProps {
  participationOverview: ParticipationOverview;
  showLoader: boolean;
}

export const defaultParticipationOverview: ParticipationOverview = {
  assessmentCount: 0,
  courseCount: 0,
  instructorCount: 0,
  studentCount: 0
};

const StudentLearningAssesment = ({
  participationOverview,
  showLoader
}: StudentLearningAssesmentProps) => {
  return (
    <div className="wm-grid-row student-learning-assesment">
      <span
        className="sr-only faculty-loader-status"
        role="status"
        aria-live="assertive"
      ></span>
      <div className="grid-container wm-grid-col-12 wm-grid-col-md-10">
        <div className="paper-card paper-card-height">
          <div className="header">
            <div className="info">
              <h3 className="title">
                {translate("app.studentLearningAssesment.widgetLabel")}
              </h3>
              <p className="description">
                {translate("app.studentLearningAssesment.widgetDescription")}
              </p>
            </div>
          </div>

          <div>
            {showLoader ? (
              <WidgetLoader
                loaderContainerClasses="loader"
                loaderClasses="content"
              />
            ) : (
              <RenderParticipationOverview
                participationOverview={participationOverview}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

interface ParticipationOverviewProps {
  participationOverview: ParticipationOverview;
}

const RenderParticipationOverview = ({
  participationOverview
}: ParticipationOverviewProps): JSX.Element => {
  if (participationOverview.studentCount === 0) {
    return <EmptyState />;
  } else {
    return (
      <ParticipationOverviewDetails
        participationOverview={participationOverview}
      />
    );
  }
};

const ParticipationOverviewDetails = ({
  participationOverview
}: ParticipationOverviewProps) => {
  return (
    <div className="body student-learning-assesment-content">
      <div className=" -detail participation">
        <div className="detail-label">
          {translate("app.studentLearningAssessment.participation")}
        </div>
        <div className="-detail-value">
          <div className="assesment-count">
            {participationOverview.studentCount}
          </div>
          <div className="assesment-label">
            {translate("app.studentLearningAssessment.student")}
          </div>
        </div>
      </div>
      <div className="-detail course-assessing">
        <div className="detail-label">
          {translate("app.studentLearningAssessment.assessment")}
        </div>
        <div className="-detail-value">
          <div className="assesment-count">
            {participationOverview.courseCount}
          </div>
          <div className="assesment-label">
            {translate("app.studentLearningAssessment.course")}
          </div>
        </div>
      </div>
      <div className="-detail instructors-assessing">
        <div className="-detail-value">
          <div className="assesment-count">
            {participationOverview.instructorCount}
          </div>
          <div className="assesment-label">
            {translate("app.studentLearningAssessment.instructor")}
          </div>
        </div>
      </div>
      <div className="assessments -detail">
        <div className="-detail-value">
          <div className="assesment-count">
            {participationOverview.assessmentCount}
          </div>
          <div className="assesment-label">
            {translate("app.studentLearningAssessment.assessments")}
          </div>
        </div>
      </div>
    </div>
  );
};
const EmptyState = () => {
  return (
    <div className="academic-yr-empty-state flex-row">
      <div>
        <div className="empty-state-title">
          {translate("app.studentLearningAssesment.termEmptyState")}
        </div>
        <div className="empty-state-desc">
          {translate("app.studentLearningAssesment.termEmptyStateDesc")}
        </div>
      </div>
    </div>
  );
};

export default StudentLearningAssesment;
